import { FolderContent } from '@/api/generatedApi';
import { FolderTreeNode } from '@/utils/buildFolderTree';
import { pluralize } from '@/utils/format';
import { Box, Typography } from '@mui/material';
import { FolderTree } from '../MoveFolderModal/FolderTree';

export const FolderSelectionContent = ({
  contents,
  folderTree,
  currentFolderId,
  expandedItems,
  disabledFolderIds,
  isLoading,
  treeContainerRef,
  onSelect,
  onExpandedItemsChange,
}: {
  contents: FolderContent[];
  folderTree: FolderTreeNode[];
  currentFolderId: string | undefined;
  expandedItems: string[];
  disabledFolderIds: Set<string>;
  isLoading: boolean;
  treeContainerRef: (node: HTMLDivElement | null) => void;
  onSelect: (event: React.SyntheticEvent | null, itemId: string | null) => void;
  onExpandedItemsChange: (event: React.SyntheticEvent | null, itemIds: string[]) => void;
}) => (
  <>
    <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
      Select a destination for {pluralize(contents.length, 'item', 'items')}
    </Typography>
    <Box
      ref={treeContainerRef}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        padding: 1,
        maxHeight: 300,
        overflow: 'auto',
      }}
    >
      <FolderTree
        folderTree={folderTree}
        selectedFolderId={currentFolderId}
        expandedItems={expandedItems}
        disabledFolderIds={disabledFolderIds}
        isLoading={isLoading}
        onSelect={onSelect}
        onExpandedItemsChange={onExpandedItemsChange}
      />
    </Box>
  </>
);
